// extracted by mini-css-extract-plugin
export default {"sidebar":"IntegrationSidebar_sidebar__1W2Jk","sidebar__wrapper":"IntegrationSidebar_sidebar__wrapper__U63V8"};